// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ylgf","type":"styles_type__2TCB3","choices":"styles_choices__30LS3"};